import React from 'react';
import { withTheme } from 'glamorous';

import { alpha } from '../../../styles';
import Nav from './Nav';

const styleHomeNav = props => ({
  justifyContent: 'center',
  position: 'absolute',
  width: '100%',
  background: alpha(props.theme.primary.darkest, 0.24),
  ...props.style,
});

const HomeNav = props => (
  <Nav {...props} style={styleHomeNav(props)}>
    {props.children}
  </Nav>
);

export default withTheme(HomeNav);



// WEBPACK FOOTER //
// ./src/components/layout/Nav/HomeNav.js